/*
 * 負責控制該專案的path to View Compoment 設定
 */
import _ from 'lodash';
import { store } from '../reducers';
import { withRouter } from 'react-router';
import { wConnectRedux } from '../reducers';
// import { LayoutType } from '../layouts/Layout/LayoutFactory';
import ErrorPage from '../views/SystemInfo/ErrorPage';
import InfoPage from '../views/SystemInfo/InfoPage';
const LayoutType = {};
// 要綁定wConnectRedux，
// 所以只用一次的compoment就直接用require('{module_path}').default
// 重複使用的compoment才用import
const StoreList = withRouter(
  wConnectRedux(require('../views/Store/StoreList').default)
);

// 此處先看wp_slug
// news
// mall
// stores
// repair
const routerData = [
  // 此處對應init.php:生成wordpress的側邊目錄
  // web.js對應要掛載的Component
  {
    wp_slug: 'news',
    path: '/',
    component: withRouter(
      wConnectRedux(require('../views/News/NewsList').default)
    ),
    layout: LayoutType.Full,
    roles: null,
    exact: true,
  },
  {
    wp_slug: 'stores',
    path: '/',
    component: withRouter(
      wConnectRedux(require('../views/Store/StoreList').default)
    ),
    layout: LayoutType.Full,
    roles: null,
    exact: true,
  },
  {
    wp_slug: 'brands',
    path: '/',
    component: withRouter(
      wConnectRedux(require('../views/Brand/BrandList').default)
    ),
    layout: LayoutType.Full,
    roles: null,
    exact: true,
  },
  {
    wp_slug: 'category',
    path: '/',
    component: withRouter(
      wConnectRedux(require('../views/Category/CategoryList').default)
    ),
    layout: LayoutType.Full,
    roles: null,
    exact: true,
  },
  {
    wp_slug: 'catalogues',
    path: '/',
    component: withRouter(
      wConnectRedux(require('../views/Catalogue/CatalogueList').default)
    ),
    layout: LayoutType.Full,
    roles: null,
    exact: true,
  },
  {
    wp_slug: 'recipes',
    path: '/',
    component: withRouter(
      wConnectRedux(require('../views/Recipe/RecipeList').default)
    ),
    layout: LayoutType.Full,
    roles: null,
    exact: true,
  },
  {
    wp_slug: 'vendors',
    path: '/',
    component: withRouter(
      wConnectRedux(require('../views/Vendor/VendorList').default)
    ),
    layout: LayoutType.Full,
    roles: null,
    exact: true,
  },
  {
    wp_slug: 'cibc',
    path: '/',
    component: withRouter(
      wConnectRedux(require('../views/CIBC/CIBCList').default)
    ),
    layout: LayoutType.Full,
    roles: null,
    exact: true,
  },
  {
    wp_slug: 'privileges',
    path: '/',
    component: withRouter(
      wConnectRedux(require('../views/Privilege/PrivilegeList').default)
    ),
    layout: LayoutType.Full,
    roles: null,
    exact: true,
  },
  {
    wp_slug: 'static',
    path: '/',
    component: withRouter(
      wConnectRedux(require('../views/Static/StaticInfo').default)
    ),
    layout: LayoutType.Full,
    roles: null,
    exact: true,
  },
  {
    wp_slug: 'hotkeywords',
    path: '/',
    component: withRouter(
      wConnectRedux(require('../views/HotKeywords/HotKeywordsInfo').default)
    ),
    layout: LayoutType.Full,
    roles: null,
    exact: true,
  },
  // { wp_slug: 'news'  , path: '/', component: ErrorPage, layout: LayoutType.Full, roles: null, exact: true },
  // { wp_slug: 'repair', path: '/', component: ErrorPage, layout: LayoutType.Full, roles: null, exact: true },

  // 最新消息管理
  {
    wp_slug: null,
    path: '/news',
    component: withRouter(
      wConnectRedux(require('../views/News/NewsList').default)
    ),
    layout: LayoutType.Full,
    roles: null,
    exact: true,
  },
  {
    wp_slug: null,
    path: '/news/view/:id?',
    component: withRouter(
      wConnectRedux(require('../views/News/NewsInfo').default)
    ),
    layout: LayoutType.Full,
    roles: null,
    exact: true,
  },

  // 分店管理
  {
    wp_slug: null,
    path: '/stores',
    component: withRouter(
      wConnectRedux(require('../views/Store/StoreList').default)
    ),
    layout: LayoutType.Full,
    roles: null,
    exact: true,
  },
  {
    wp_slug: null,
    path: '/stores/view/:id?',
    component: withRouter(
      wConnectRedux(require('../views/Store/StoreInfo').default)
    ),
    layout: LayoutType.Full,
    roles: null,
    exact: true,
  },

  // 品牌管理
  {
    wp_slug: null,
    path: '/brands',
    component: withRouter(
      wConnectRedux(require('../views/Brand/BrandList').default)
    ),
    layout: LayoutType.Full,
    roles: null,
    exact: true,
  },
  {
    wp_slug: null,
    path: '/brands/view/:id?',
    component: withRouter(
      wConnectRedux(require('../views/Brand/BrandInfo').default)
    ),
    layout: LayoutType.Full,
    roles: null,
    exact: true,
  },

  // 品牌類別管理
  {
    wp_slug: null,
    path: '/category',
    component: withRouter(
      wConnectRedux(require('../views/Category/CategoryList').default)
    ),
    layout: LayoutType.Full,
    roles: null,
    exact: true,
  },
  {
    wp_slug: null,
    path: '/category/view/:id?',
    component: withRouter(
      wConnectRedux(require('../views/Category/CategoryInfo').default)
    ),
    layout: LayoutType.Full,
    roles: null,
    exact: true,
  },

  // 促銷目錄
  {
    wp_slug: null,
    path: '/catalogues',
    component: withRouter(
      wConnectRedux(require('../views/Catalogue/CatalogueList').default)
    ),
    layout: LayoutType.Full,
    roles: null,
    exact: true,
  },
  {
    wp_slug: null,
    path: '/catalogues/view/:id?',
    component: withRouter(
      wConnectRedux(require('../views/Catalogue/CatalogueInfo').default)
    ),
    layout: LayoutType.Full,
    roles: null,
    exact: true,
  },

  // 食譜管理
  {
    wp_slug: null,
    path: '/recipes',
    component: withRouter(
      wConnectRedux(require('../views/Recipe/RecipeList').default)
    ),
    layout: LayoutType.Full,
    roles: null,
    exact: true,
  },
  {
    wp_slug: null,
    path: '/recipes/view/:id?',
    component: withRouter(
      wConnectRedux(require('../views/Recipe/RecipeInfo').default)
    ),
    layout: LayoutType.Full,
    roles: null,
    exact: true,
  },

  // 第三方平台管理
  {
    wp_slug: null,
    path: '/vendors',
    component: withRouter(
      wConnectRedux(require('../views/Vendor/VendorList').default)
    ),
    layout: LayoutType.Full,
    roles: null,
    exact: true,
  },
  {
    wp_slug: null,
    path: '/vendors/view/:id?',
    component: withRouter(
      wConnectRedux(require('../views/Vendor/VendorInfo').default)
    ),
    layout: LayoutType.Full,
    roles: null,
    exact: true,
  },
  // 權限管理
  {
    wp_slug: null,
    path: '/privileges',
    component: withRouter(
      wConnectRedux(require('../views/Privilege/PrivilegeList').default)
    ),
    layout: LayoutType.Full,
    roles: null,
    exact: true,
  },
  {
    wp_slug: null,
    path: '/privileges/view/:id?',
    component: withRouter(
      wConnectRedux(require('../views/Privilege/PrivilegeInfo').default)
    ),
    layout: LayoutType.Full,
    roles: null,
    exact: true,
  },
  // 保經管理
  {
    wp_slug: null,
    path: '/cibc',
    component: withRouter(
      wConnectRedux(require('../views/CIBC/CIBCList').default)
    ),
    layout: LayoutType.Full,
    roles: null,
    exact: true,
  },
  {
    wp_slug: null,
    path: '/cibc/view/:id?',
    component: withRouter(
      wConnectRedux(require('../views/CIBC/CIBCInfo').default)
    ),
    layout: LayoutType.Full,
    roles: null,
    exact: true,
  },
  // 靜態頁面
  {
    wp_slug: null,
    path: '/static',
    component: withRouter(
      wConnectRedux(require('../views/Static/StaticInfo').default)
    ),
    layout: LayoutType.Full,
    roles: null,
    exact: true,
  },
  // 熱門關鍵字頁面
  {
    wp_slug: null,
    path: '/hotkeywords',
    component: withRouter(
      wConnectRedux(require('../views/HotKeywords/HotKeywordsInfo').default)
    ),
    layout: LayoutType.Full,
    roles: null,
    exact: true,
  },

  // 系統訊息
  {
    path: '/system/info/:message',
    component: InfoPage,
    layout: LayoutType.Full,
  },
  { path: '/error', component: ErrorPage, layout: LayoutType.Full },
];

export const getRouterData = (hasPermissions = null) => {
  if (_.isNil(hasPermissions)) {
    const userPermissions = _.get(store.getState(), 'auth.permissions', {});

    hasPermissions = _.keys(userPermissions).filter(
      (k) => userPermissions[k] === true
    );
  }

  return routerData.filter((item) => {
    if (_.isNil(item.permissions) || _.isEmpty(item.permissions)) return true;

    item.permissions = _.isArray(item.permissions)
      ? item.permissions
      : [item.permissions];

    return _.intersection(item.permissions, hasPermissions).length > 0;
  });
};



// WEBPACK FOOTER //
// ./src/routes/web.js